// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Selector$SmartcutsMacros = require("../Selector.bs.js");
var StringUtils$SmartcutsMacros = require("../../../bs-utils/src/StringUtils.bs.js");
var DataDependency$SmartcutsMacros = require("../commands/shared/DataDependency.bs.js");

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "playbackFormLabel",
                Decco.stringToJson(v.playbackFormLabel)
              ],
              [
                "defaultValue",
                Decco.stringToJson(v.defaultValue)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var playbackFormLabel = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackFormLabel"), null));
  if (playbackFormLabel.TAG === /* Ok */0) {
    var defaultValue = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "defaultValue"), null));
    if (defaultValue.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                playbackFormLabel: playbackFormLabel._0,
                defaultValue: defaultValue._0
              }
            };
    }
    var e = defaultValue._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".defaultValue" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = playbackFormLabel._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".playbackFormLabel" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

var VariableInnerTextConfig = {
  t_encode: t_encode,
  t_decode: t_decode
};

function t_encode$1(v) {
  if (typeof v === "number") {
    return ["AnyInnerText"];
  }
  switch (v.TAG | 0) {
    case /* MatchesFullInnerText */0 :
        return [
                "MatchesFullInnerText",
                Curry._1(DataDependency$SmartcutsMacros.DataRef.t_encode, v._0)
              ];
    case /* MatchesInnerTextPrefix */1 :
        return [
                "MatchesInnerTextPrefix",
                Curry._1(DataDependency$SmartcutsMacros.DataRef.t_encode, v._0)
              ];
    case /* ContainsInnerText */2 :
        return [
                "ContainsInnerText",
                Curry._1(DataDependency$SmartcutsMacros.DataRef.t_encode, v._0)
              ];
    case /* ContainsInnerTextEnum */3 :
        return [
                "ContainsInnerTextEnum",
                Decco.stringToJson(v._0),
                Decco.stringToJson(v._1),
                Decco.arrayToJson(Decco.stringToJson, v._2)
              ];
    case /* ContainsInnerTextAllStrings */4 :
        return [
                "ContainsInnerTextAllStrings",
                Decco.stringToJson(v._0),
                Decco.stringToJson(v._1),
                Decco.arrayToJson(Decco.stringToJson, v._2)
              ];
    case /* VariableInnerText */5 :
        return [
                "VariableInnerText",
                t_encode(v._0)
              ];
    
  }
}

function t_decode$1(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "AnyInnerText" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* AnyInnerText */0
                  };
          }
      case "ContainsInnerText" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Curry._1(DataDependency$SmartcutsMacros.DataRef.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ContainsInnerText */2,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "ContainsInnerTextAllStrings" :
          if (tagged.length !== 4) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
          var match$3 = Decco.arrayFromJson(Decco.stringFromJson, Belt_Array.getExn(jsonArr$1, 3));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              if (match$3.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          TAG: /* ContainsInnerTextAllStrings */4,
                          _0: match$1._0,
                          _1: match$2._0,
                          _2: match$3._0
                        }
                      };
              }
              var e$1 = match$3._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: "[2]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                      }
                    };
            }
            var e$2 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "ContainsInnerTextEnum" :
          if (tagged.length !== 4) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$4 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$5 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
          var match$6 = Decco.arrayFromJson(Decco.stringFromJson, Belt_Array.getExn(jsonArr$1, 3));
          if (match$4.TAG === /* Ok */0) {
            if (match$5.TAG === /* Ok */0) {
              if (match$6.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          TAG: /* ContainsInnerTextEnum */3,
                          _0: match$4._0,
                          _1: match$5._0,
                          _2: match$6._0
                        }
                      };
              }
              var e$4 = match$6._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: "[2]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                      }
                    };
            }
            var e$5 = match$5._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$5.path,
                      message: e$5.message,
                      value: e$5.value
                    }
                  };
          }
          var e$6 = match$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
      case "MatchesFullInnerText" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Curry._1(DataDependency$SmartcutsMacros.DataRef.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* MatchesFullInnerText */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$7 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                  }
                };
      case "MatchesInnerTextPrefix" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = Curry._1(DataDependency$SmartcutsMacros.DataRef.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* MatchesInnerTextPrefix */1,
                      _0: v0$2._0
                    }
                  };
          }
          var e$8 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                  }
                };
      case "VariableInnerText" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* VariableInnerText */5,
                      _0: v0$3._0
                    }
                  };
          }
          var e$9 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$9.path,
                    message: e$9.message,
                    value: e$9.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify(v) {
  if (typeof v === "number") {
    return "AnyInnerText";
  }
  switch (v.TAG | 0) {
    case /* MatchesFullInnerText */0 :
        return "MatchesFullInnerText(" + (Curry._1(DataDependency$SmartcutsMacros.DataRef.stringify, v._0) + ")");
    case /* MatchesInnerTextPrefix */1 :
        return "MatchesInnerTextPrefix(" + (Curry._1(DataDependency$SmartcutsMacros.DataRef.stringify, v._0) + ")");
    case /* ContainsInnerText */2 :
        return "ContainsInnerText(" + (Curry._1(DataDependency$SmartcutsMacros.DataRef.stringify, v._0) + ")");
    case /* ContainsInnerTextEnum */3 :
        return "ContainsInnerTextEnum(" + (StringUtils$SmartcutsMacros.quote(v._0) + (", " + (StringUtils$SmartcutsMacros.quote(v._1) + (", [" + (v._2.join(", ") + "])")))));
    case /* ContainsInnerTextAllStrings */4 :
        return "ContainsInnerTextAllStrings(" + (StringUtils$SmartcutsMacros.quote(v._0) + (", " + (StringUtils$SmartcutsMacros.quote(v._1) + (", [" + (v._2.join(", ") + "])")))));
    case /* VariableInnerText */5 :
        var match = v._0;
        return "VariableInnerText({playbackFormLabel: " + (match.playbackFormLabel + (", defaultValue=" + (match.defaultValue + "})")));
    
  }
}

function isDynamic(v) {
  if (typeof v === "number" || v.TAG !== /* VariableInnerText */5) {
    return false;
  } else {
    return true;
  }
}

function getPrefixIntentionChoicesFromInnerText(text) {
  return Belt_Array.map(StringUtils$SmartcutsMacros.splitIntoPrefixesAtMost(text, 3), (function (prefix) {
                return {
                        TAG: /* MatchesInnerTextPrefix */1,
                        _0: {
                          TAG: /* StaticText */0,
                          _0: prefix
                        }
                      };
              }));
}

function getIntentionChoicesFromSelector(selector) {
  var match = Selector$SmartcutsMacros.maybeGetLeafNode(selector);
  if (match === undefined) {
    return [];
  }
  var innerText = match.innerText;
  if (typeof innerText === "number") {
    if (innerText === /* Ignored */0) {
      return [];
    } else {
      return [];
    }
  }
  if (innerText.TAG === /* FullInnerText */0) {
    var text = innerText._0;
    return $$Array.concat({
                hd: [
                  /* AnyInnerText */0,
                  {
                    TAG: /* ContainsInnerText */2,
                    _0: {
                      TAG: /* StaticText */0,
                      _0: text
                    }
                  },
                  {
                    TAG: /* MatchesFullInnerText */0,
                    _0: {
                      TAG: /* StaticText */0,
                      _0: text
                    }
                  }
                ],
                tl: {
                  hd: getPrefixIntentionChoicesFromInnerText(text),
                  tl: {
                    hd: [
                      {
                        TAG: /* ContainsInnerTextEnum */3,
                        _0: text,
                        _1: "example phrase you can delete",
                        _2: []
                      },
                      {
                        TAG: /* VariableInnerText */5,
                        _0: {
                          playbackFormLabel: "[Add Label]",
                          defaultValue: text
                        }
                      }
                    ],
                    tl: /* [] */0
                  }
                }
              });
  }
  var text$1 = innerText._0;
  return $$Array.concat({
              hd: [
                /* AnyInnerText */0,
                {
                  TAG: /* ContainsInnerText */2,
                  _0: {
                    TAG: /* StaticText */0,
                    _0: text$1
                  }
                }
              ],
              tl: {
                hd: getPrefixIntentionChoicesFromInnerText(text$1),
                tl: {
                  hd: [
                    {
                      TAG: /* ContainsInnerTextEnum */3,
                      _0: text$1,
                      _1: "example phrase you can delete",
                      _2: []
                    },
                    {
                      TAG: /* VariableInnerText */5,
                      _0: {
                        playbackFormLabel: "[Add Label]",
                        defaultValue: text$1
                      }
                    }
                  ],
                  tl: /* [] */0
                }
              }
            });
}

function mapDataRef(f, v) {
  if (typeof v === "number") {
    return /* AnyInnerText */0;
  }
  switch (v.TAG | 0) {
    case /* MatchesFullInnerText */0 :
        return {
                TAG: /* MatchesFullInnerText */0,
                _0: Curry._1(f, v._0)
              };
    case /* MatchesInnerTextPrefix */1 :
        return {
                TAG: /* MatchesInnerTextPrefix */1,
                _0: Curry._1(f, v._0)
              };
    case /* ContainsInnerText */2 :
        return {
                TAG: /* ContainsInnerText */2,
                _0: Curry._1(f, v._0)
              };
    case /* ContainsInnerTextEnum */3 :
        return {
                TAG: /* ContainsInnerTextEnum */3,
                _0: v._0,
                _1: v._1,
                _2: v._2
              };
    case /* ContainsInnerTextAllStrings */4 :
        return {
                TAG: /* ContainsInnerTextAllStrings */4,
                _0: v._0,
                _1: v._1,
                _2: v._2
              };
    case /* VariableInnerText */5 :
        return {
                TAG: /* VariableInnerText */5,
                _0: v._0
              };
    
  }
}

function updatePlaybackFormLabel(playbackFormLabel, semantic) {
  if (typeof semantic === "number" || semantic.TAG !== /* VariableInnerText */5) {
    return semantic;
  } else {
    return {
            TAG: /* VariableInnerText */5,
            _0: {
              playbackFormLabel: playbackFormLabel,
              defaultValue: semantic._0.defaultValue
            }
          };
  }
}

exports.VariableInnerTextConfig = VariableInnerTextConfig;
exports.t_encode = t_encode$1;
exports.t_decode = t_decode$1;
exports.stringify = stringify;
exports.isDynamic = isDynamic;
exports.getIntentionChoicesFromSelector = getIntentionChoicesFromSelector;
exports.mapDataRef = mapDataRef;
exports.updatePlaybackFormLabel = updatePlaybackFormLabel;
/* Selector-SmartcutsMacros Not a pure module */
